import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { can } from "../auth/permissions";
import NotPermitted from "../views/NotPermitted";

// Route guard. Accepts either `allowedRoles` (legacy) or a `capability` from
// src/auth/permissions.js. While the session is still bootstrapping it renders
// nothing, so a direct deep link never bounces to /login before restoration.
const RequireAuth = ({ allowedRoles, capability, fallback }) => {
  const { isBootstrapping, isAuthenticated, role } = useAuth();
  const location = useLocation();

  if (isBootstrapping) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const permitted = capability
    ? can(role, capability)
    : Array.isArray(allowedRoles)
      ? allowedRoles.includes(role)
      : true;

  if (!permitted) {
    return fallback || <NotPermitted />;
  }

  return <Outlet />;
};

export default RequireAuth;
